import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  /** CTA opcional (botão) exibido abaixo da descrição. */
  children?: ReactNode;
}

/** Estado vazio: ícone grande em círculo roxo suave + título + descrição + ação opcional. */
export function EmptyState({ icon: Icon, title, description, children }: EmptyStateProps) {
  return (
    <div className="grid place-items-center rounded-lg border border-dashed border-border bg-surface px-6 py-16 text-center shadow-card">
      <span className="grid size-16 place-items-center rounded-full bg-primary-weak text-primary">
        <Icon className="size-8" />
      </span>
      <h2 className="mt-4 text-lg font-semibold text-ink">{title}</h2>
      {description && <p className="mt-1 max-w-sm text-sm text-muted">{description}</p>}
      {children && <div className="mt-5">{children}</div>}
    </div>
  );
}
